module.exports = "data:image/gif;base64,R0lGODlhDAAJAMQSAGhoaJGRkWRkZH19fbi4uJWVlXx8fHV1dZycnIeHh7m5uXd3d8HBwWJiYnBwcHt7e2lpaXZ2dv///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEAABIALAAAAAAMAAkAAAUi4CGNZCk9i2kCTKSSgEIYrwQESAG9dyLUgEGjZvsRHcRRCAA7"


/*****************
 ** WEBPACK FOOTER
 ** ./extjs/resources/themes/images/gray/menu/menu-parent.gif
 ** module id = 491
 ** module chunks = 0
 **/